import { render, staticRenderFns } from "./WizardUnidades.vue?vue&type=template&id=27b858b4"
import script from "./WizardUnidades.vue?vue&type=script&lang=js"
export * from "./WizardUnidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports